import {
  useUserMeInterestUnreadCount,
  useUserMeScoutUnreadCount,
} from '../repositories/usersMeRepository';
import {useAuth} from './auth/AuthContext';
import {useTodayDeadlineRecruitmentCount} from './useTodayDeadlineRecruitmentCount';

export const useAttentionCounts = () => {
  const {status} = useAuth();
  const {count: scoutsCount} = useUserMeScoutUnreadCount({
    config: {enabled: status === 'authenticated'},
  });
  const {count: interestsCount} = useUserMeInterestUnreadCount({
    config: {enabled: status === 'authenticated'},
  });
  const {count: todayDeadlineRecruitmentCount} =
    useTodayDeadlineRecruitmentCount();
  return {
    scoutsCount: scoutsCount ?? 0,
    interestsCount: interestsCount ?? 0,
    todayDeadlineRecruitmentCount,
  };
};
